import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Box, createStyles, LinearProgress, Theme, Typography } from '@material-ui/core';

export interface ProgressBarProps {
  current?: number;
  total?: number;
}

export const useClasses = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: 10,
      borderRadius: 5,
    },
    colorPrimary: {
      backgroundColor: theme.palette.grey[200],
    },
    bar: {
      borderRadius: 5,
      backgroundColor: theme.palette.primary.main,
    },
  })
);

const ProgressBar: React.FC<ProgressBarProps> = ({ current, total }) => {
  const theme = useTheme();
  const classes = useClasses(theme);
  return (
    <Box display="flex" alignItems="center" my={2}>
      <Box width="100%" mr={2}>
        <LinearProgress
          classes={classes}
          value={total ? (current / total) * 100 : 0}
          variant={'determinate'}
        />
      </Box>
      <Box minWidth={35}>
        <Typography variant="body2" color="textSecondary">
          {current + '/' + total}
        </Typography>
      </Box>
    </Box>
  );
};

export default ProgressBar;
